export default __webpack_public_path__ + "static/media/element_spec_75.1b8b4a45.jpg";